<template>
  <div>
    <v-icon @click="dialog = true" class="mr-2" color="warning"
      >mdi-pencil</v-icon
    >
    <v-dialog v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title>Edit Employee</v-card-title>
        <v-card-text>
          <div>
            <v-form ref="form">
              <!-- {{ item.is_active }} -->
              <v-radio-group v-model="item.is_active" row label="Active Status">
                <v-radio label="Inactive" :value="0"></v-radio>
                <v-radio label="Active" :value="1"></v-radio>
              </v-radio-group>
              <v-text-field
                label="Employee Name"
                v-model="item.name"
                prepend-icon="mdi-account-circle"
                :rules="rules"
              ></v-text-field>
              <v-text-field
                label="Contact Number"
                v-model="item.contact_no"
                prepend-icon="mdi-phone"
                :rules="rules"
              ></v-text-field>
              <v-text-field
                label="Address"
                v-model="item.address"
                prepend-icon="mdi-map-marker"
                :rules="rules"
              ></v-text-field>
              <div class="d-flex">
                <p>Birth Date</p>
                <input type="date" v-model="item.birth_date" class="" />
              </div>
              <v-select
                label="Position"
                :items="['Clerk', 'Admin Assistant', 'Technician']"
                prepend-icon="mdi-tools"
                :rules="rules"
                v-model="item.position"
              ></v-select>
              <v-text-field
                label="Daily Rate"
                v-model="item.daily_rate"
                prepend-icon="mdi-hand-coin"
                :rules="rules"
              ></v-text-field>
              <div class="d-flex">
                <p>Employment Date</p>
                <input type="date" v-model="item.date_of_employment" class="" />
              </div>
            </v-form>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="submit" :loading="loading">Add</v-btn>
          <v-btn @click="dialog = false"> Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["item"],
  data() {
    return {
      dialog: false,
      form: {},
      rules: [(value) => !!value || "Field is Required."],
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      edit_employee: "employee/edit_employee",
    }),
    submit() {
      if (this.$refs.form.validate()) {
        let x = window.confirm(
          "Are you sure you want to add this new employee?"
        );
        if (x) {
          this.loading = true;
          this.edit_employee(this.item)
            .then(() => {
              alert("Successfully edited a new employee");
              this.loading = false;
            })
            .catch((err) => alert(err));
        }
      } else {
        alert("Please check some fields");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
